import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import Moment from 'moment';
import $ from "jquery";
import DatePicker, { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {DropDownList} from '../../Elements/Select/dropdown';
import {showModalPageClass, hideModalPageClass} from '../../../functions';

class Emailing extends Component {
    constructor (props){
        super(props);
        this.state = {
            pagina:     1,
            loading:    true,
            data:       [],
            error:      [],
            roles:      [],
            response:   [],
            users:      [],
            security:   cookie.load('user'),
            
            // Filtros
            filtroSector: 0,
            filtroEstado: 0,
            searchText: "",
            
            // Filtros Año y Mes
            filtroYYYY: new Date().getFullYear(),
            filtroMM: 0,
            
            mensajeResultado: ""
        }

        this.getData = this.getData.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.paginationTable = this.paginationTable.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAction = this.handleAction.bind(this);
        this.filter = this.filter.bind(this);
        this.downloadEmailing = this.downloadEmailing.bind(this);
    }

    componentDidMount(){
        this.getData(1);
    }

    handleInputChange(event){
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        // Si es un objeto (viene del DropDownList), extraer solo el valor
        if (typeof value === 'object' && value !== null) {
            value = value.value || value.id || 0;
        }

        this.setState({
            [name]: value
        });
    }

    filter(e){
        if(e) e.preventDefault(); 
        this.getData(1);
    }

    async getData(pagina){
        console.log('Estado actual:', {
            filtroSector: this.state.filtroSector,
            filtroEstado: this.state.filtroEstado,
            filtroYYYY: this.state.filtroYYYY,
            filtroMM: this.state.filtroMM,
            searchText: this.state.searchText
        });

        this.setState({
            loading: true,
            pagina: pagina
        }, () => {
        });

        try {
            const usuario = (this.state.security && this.state.security.nUsuCodigo) ? this.state.security.nUsuCodigo : 0;
            const estado = this.state.filtroEstado || '0';
            
            let sector = this.state.filtroSector;
            if (typeof sector === 'object' && sector !== null) {
                sector = sector.value || sector.id || '0';
            }
            sector = sector || '0';
            
            const nombre = this.state.searchText && this.state.searchText.trim() !== '' 
                ? this.state.searchText.trim() 
                : 'a';
            const anio = this.state.filtroYYYY || '0';
            const mes = this.state.filtroMM || '0';
            const tipo = '0';
            
            const baseUrl = `${API_URL}EmailingUX`; 
            const url = `${baseUrl}/${pagina}/${estado}/${usuario}/${anio}/${mes}/${encodeURIComponent(sector)}/${tipo}/${encodeURIComponent(nombre)}`;

            // console.log('URL de petición:', url); 
            const res = await axios.get(url, { timeout: 15000 });
            if(res.data && res.data.isSucess){
                console.log('Datos recibidos:', res.data.result?.length || 0, 'items');
                this.setState({
                    data: res.data.result || [],
                    response: res.data,
                    loading: false
                }, () => {
                });
            } else {
                this.setState({
                    loading: false,
                    response: res.data,
                    data: [] 
                }, () => {
                });
                if (res.data && res.data.StatusMessage) {
                    toast.warning(res.data.StatusMessage);
                }
            }
        } catch (error) {
            this.setState({
                loading: false, 
                data: [],
                response: { isSucess: false, StatusMessage: "Error de conexión" }
            }, () => {
            });
            
            if (error.code === 'ECONNABORTED') {
                toast.error("La solicitud ha excedido el tiempo de espera.");
            } else if (error.response) {
                toast.error(`Error del servidor: ${error.response.status}`);
            } else if (error.request) {
                toast.error("No se pudo conectar con el servidor.");
            } else {
                toast.error("Error inesperado al procesar la solicitud.");
            }
        }
    }

    paginationTable(){
        let totalPages = this.state.response.result ? this.state.response.result.totalPages : 1;
        let currentPage = this.state.pagina;

        if (totalPages > 1){
            return (
                <div className="text-center">
                    <ul className="pagination text-center">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); this.getData(currentPage - 1) }} className="page-link">Anterior</a>
                        </li>
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); this.getData(currentPage + 1) }} className="page-link">Siguiente</a>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    handleNew(){
        this.props.history.push('/add-emailing');
    }

// Acciones
    handleAction(e, action, item){
        if(e) e.preventDefault();

        const id = item.emai_Id || item.eMail_Codigo;
        const asunto = item.emai_Asunto || item.eMail_Asunto || "documento";

        if (action === 'edit'){
            this.props.history.push(`edit-emailing/${id}`);
        } 
        else if (action === 'delete'){
            if(window.confirm(`¿Está seguro de eliminar el Emailing "${asunto}"?`)){
                this.deleteEmailing(id, item); 
            }
        } 
        else if (action === 'view'){
            showModalPageClass('emailing-view-modal'); 
        } 
        else if (action === 'download'){
            this.downloadEmailing(id, asunto);
        }
    }

    async deleteEmailing(id, item) {
        console.log("items a eliminar", item);
        
        const payloadObj = {
            emai_Id: id,
            emai_UsuarioEdicion: this.state.security.nUsuCodigo,
        };

        const body = JSON.stringify(payloadObj);
        this.setState({ loading: true });

        try {
            const url = `${API_URL}EmailingUX/`;
            
            const res = await axios.delete(url, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Accept': 'application/json'
                },
                data: JSON.stringify(body) 
            });

            if (res.data && res.data.isSucess) {
                toast.success("El registro ha sido eliminado correctamente.");
                this.getData(this.state.pagina);  
            } else {
                toast.error(res.data.statusMessage || "No se pudo eliminar el registro.");
                this.setState({ loading: false });  
            }

        } catch (error) {
            console.error("Error al eliminar:", error);
            this.setState({ loading: false }); 
            
            if (error.response) {
                toast.error(`Error del servidor: ${error.response.status}`);
            } else {
                toast.error("Ocurrió un error de conexión al intentar eliminar.");
            }
        }
    }

    async downloadEmailing(id, nombreArchivo) {
        toast.info("Generando archivo para descarga...");
        
        try {
            const url = `${API_URL}EmailingUX/DownloadHTML/${id}`;
            const res = await axios.get(url);

            if (res.data && res.data.statusCode === 200 && res.data.result) {
                const htmlContent = res.data.result.emai_HTML; 
                if(!htmlContent){
                    toast.warning("El archivo no tiene contenido HTML.");
                    return;
                }

                const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                const safeName = (nombreArchivo || "emailing").replace(/[^a-z0-9]/gi, '_').toLowerCase();
                link.download = `${safeName}.html`;
                
                document.body.appendChild(link);
                link.click();
                
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);

                toast.success("Descarga completada.");
            } else {
                toast.error(res.data.statusMessage || "No se pudo obtener el contenido.");
            }

        } catch (error) {
            console.error("Error al descargar:", error);
            toast.error("Error de comunicación al descargar.");
        } finally {
        }
    }


    renderEmailingViewModal(){
        return (
            <div className="modal fade" id="emailing-view-modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Visualizar Emailing Sectorial</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => hideModalPageClass('emailing-view-modal')}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Contenido del Emailing (Pendiente de implementación de detalles)</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => hideModalPageClass('emailing-view-modal')}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            (this.state.response && (this.state.response.isSucess === true || this.state.response.isSucess === undefined)) ?
                <div className="row">
                    <div className="col-12">
                        <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/">
                                                    / Panel de Configuración General
                                                </a>
                                                <Link to="/administradores">
                                                    / Administradores
                                                </Link>
                                            <span> / Emailing Sectorial</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                                Emailing Sectorial
                                            </div>
                                            
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card-box">
                                            
                                            
                                            <div className="row">
                                                
                                                {/* Filtro Año y Mes */}
                                                <div className="col-md-3 form-group">
                                                    <label>Fecha del Emaling</label>
                                                    <div className="d-flex">
                                                        <select name="filtroYYYY"
                                                            className="form-control form-control-sm w-50"
                                                            value={this.state.filtroYYYY}
                                                            onChange={(e) => this.setState({ filtroYYYY: e.target.value })}
                                                        >
                                                            <option value="0">Año</option>
                                                            {[...Array(3)].map((_, i) => {
                                                                const currentYear = new Date().getFullYear();
                                                                const year = currentYear - 1 + i;
                                                                return (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                                );
                                                            })}
                                                        </select>
                                                        <select
                                                            name="filtroMM"
                                                            className="form-control form-control-sm w-50"
                                                            value={this.state.filtroMM}
                                                            onChange={(e) => this.setState({ filtroMM: e.target.value })}
                                                        >
                                                        <option value="0">Mes</option>
                                                            {[...Array(12).keys()].map((m) => (
                                                                <option key={m + 1} value={m + 1}>
                                                                    {new Date(0, m).toLocaleString('es', { month: 'long' })}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                {/* Filtro Sector */}
                                                <div className="col-md-3 form-group">
                                                    <label>Sector</label>
                                                    <DropDownList 
                                                        valor={this.state.filtroSector}
                                                        name="filtroSector"
                                                        id="filtroSector"
                                                        onChange={this.handleInputChange}
                                                        componente={"Sector"} 
                                                    />
                                                </div>

                                                {/* Filtro Estado */}
                                                <div className="col-md-3 form-group">
                                                    <label>Estado</label>
                                                    <select
                                                        className="form-control"
                                                        name="filtroEstado"
                                                        id="filtroEstado"
                                                        value={this.state.filtroEstado}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="0">Seleccion una Opción de la lista</option>
                                                        <option value="1">Borrador</option>
                                                        <option value="2">Por validar</option>
                                                        <option value="3">Validado</option>
                                                    </select>
                                                </div>
                                                
                                                {/* Botones */}
                                                <div className="col-md-3 d-flex align-items-end form-group">
                                                    <button 
                                                        type="button" 
                                                        onClick={this.filter} 
                                                        className="btn btn-sm btn-primary mr-1" 
                                                        disabled={this.state.loading}
                                                    >
                                                        {this.state.loading ? 
                                                            <>
                                                                <i className="fas fa-spinner fa-spin"></i> Buscando...
                                                            </>
                                                            : 
                                                            "Buscar"
                                                        }
                                                    </button>
                                                    <button type="button" onClick={this.handleNew} className="btn btn-sm btn-success mr-1">
                                                        Nuevo
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Resultados */}
                                            <div className="table-responsive">
                                                <table id="datatable" className="table table-bordered dt-responsive nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Fecha Creación</th>
                                                            <th>Asunto</th>
                                                            <th>Sector</th>
                                                            <th>Estado</th>
                                                            <th>Editar</th>
                                                            <th>Eliminar</th>
                                                            <th>Descargar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.loading ? (
                                                            <tr>
                                                                <td colSpan={5} className="text-center">
                                                                    <i className="fas fa-spinner fa-spin"></i> Cargando...
                                                                </td>
                                                            </tr>
                                                        ) : this.state.data.length > 0 ? (
                                                            this.state.data.map((item, index) => {
                                                                return(
                                                                    <tr key={index}>
                                                                        <td>{Moment(item.emai_FechaCreacion).format('DD/MM/YYYY')}</td> 
                                                                        <td>{item.emai_Asunto}</td>
                                                                        <td>{item.sSector}</td>
                                                                        <td>{item.sEstado}</td> 
                                                                        <td>
                                                                            <button 
                                                                                type="button"
                                                                                onClick={(e) => this.handleAction(e, 'edit', item)} 
                                                                                className="btn btn-sm btn-warning waves-effect waves-light mr-1" 
                                                                                title="Editar">
                                                                                <i className="fas fa-edit"></i>
                                                                            </button>
                                                                        </td> 
                                                                        <td>
                                                                                <button 
                                                                                    type="button"
                                                                                    onClick={(e) => this.handleAction(e, 'delete', item)} 
                                                                                    className="btn btn-sm btn-danger waves-effect waves-light" 
                                                                                    title="Eliminar"
                                                                                >
                                                                                    <i className="fas fa-trash"></i>
                                                                                </button>                                                                            
                                                                        </td> 
                                                                        <td>
                                                                            {item.emai_Estado == 3 ? 
                                                                                <button 
                                                                                    type="button"  
                                                                                    onClick={(e) => this.handleAction(e, 'download', item)}
                                                                                    title="Descargar"
                                                                                    className="btn btn-sm btn-info waves-effect waves-light mr-1" 
                                                                                >
                                                                                    <i className="fas fa-download"></i>
                                                                                </button>
                                                                                : 
                                                                                "-"
                                                                                }                                                                        
                                                                        </td> 
                                                                    </tr>
                                                                )
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={5} className="text-center">
                                                                    Sin Emailings disponibles
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {this.state.data.length > 0 && !this.state.loading &&
                                                <div>
                                                    {this.paginationTable()}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    {/* Modal */}
                    {this.renderEmailingViewModal()} 
                </div>
            :
                <Error StatusCode={this.state.response ? this.state.response.StatusCode : 500} StatusMessage={this.state.response ? this.state.response.StatusMessage : "Error interno"}></Error>
        )
    }
}

export default Emailing;